<template>
    <div class="search_check_box">
        <div class="caption">
            {{caption}}
        </div>
        <div class="accordion" :class="{open: is_open}">
            <div
                    class="item"
                    v-for="(item, i) in items"
                    :key="i"
                    @click.stop
            >
                <input type="checkbox" :id="`${id}-${item}`" :value="item" v-model="check_input">
                <label :for="`${id}-${item}`">{{item.replace('床色：', '')}}</label>
            </div>
        </div>
        <div class="submit">
            <button @click="emit">検索</button>
        </div>
    </div>
</template>

<script>
    import { v4 as uuidv4 } from 'uuid'

    export default {
        name: "SearchCheckBox",
        props: {
            caption: String,
            items: Array,
            checked_items: {
                type: Array,
                default: () => []
            }
        },
        data: () => ({
            id: `input-${uuidv4()}`,
            checked: [],
            is_open: false
        }),
        computed: {
            check_input: {
                get() {
                    return this.checked;
                },
                set(value) {
                    this.checked = value;
                }
            }
        },
        created() {
            this.checked = [...this.checked_items];
        },
        watch: {
            checked_items() {
                this.checked = [...this.checked_items];
            }
        },
        methods: {
            emit() {
                this.$emit('change', this.checked);
                this.$emit('close');
            }
        }
    }
</script>

<style scoped lang="scss">
    .search_check_box{
        .caption{
            padding: 0.25rem 0;
            background-color: #CBA7A7;
            color: white;
            text-align: center;
        }
        .accordion{
            background-color: white;
            border-top: none;
            .item{
                padding: 0.5rem 1rem;
                font-size: 13px;
                &:not(:last-child){
                    border-bottom: dotted 2px #EADCDC;
                }
            }
            .item input[type="checkbox"]{
                display: none;
            }
            .item input[type="checkbox"]+label{
                display: none;
                cursor: pointer;
                display: inline-block;
                position: relative;
                padding-left: 25px;
                padding-right: 10px;
            }
            .item input[type="checkbox"]+label::before{
                content: "";
                position: absolute;
                display: block;
                box-sizing: border-box;
                width: 13px;
                height: 13px;
                left: 0;
                top: 50%;
                transform: translateY(-50%);
                border: 1px solid;
                border-radius: 25%;
                border-color:  #826e67;
            }
            .item input[type="checkbox"]:checked+label::after{
                content: "";
                position: absolute;
                display: block;
                box-sizing: border-box;
                width: 8px;
                height: 8px;
                transform: translate(-50%, -50%);
                top: 50%;
                left: calc(13px / 2);
                border: 3px solid;
                border-radius: 30%;
                border-color:  #c08c8b;
                background-color: #c08c8b;
            }

            label {
                width: 100%;
                /*background: #00CC00;*/
            }
        }
        .submit{
            background-color: #F2F2F2;
            padding: 0.5rem 0;
            text-align: center;
            button {
                width: 120px;
                height: 40px;
                font-size: 13px;
                /*font-weight: bold;*/
                color: white;
                background-color: #ba8989;
                border: none;
                border-radius: 8px;
            }
        }
    }
</style>
